import createCollectionResource from 'src/actions/shared/createResource';
import RoutingGroup from 'src/models/RoutingGroup/RoutingGroup';

const routingGroupsResource = createCollectionResource<RoutingGroup>({
  name: 'routingGroups',
  endpoint: 'v1/orgs/:orgId/routing-groups/:id',
  type: RoutingGroup,
});

export default routingGroupsResource;
